import { MAP_TYPE } from 'maps/types'

export const isGarmentStoresType = (type?: MAP_TYPE): boolean =>
	type === MAP_TYPE.GARMENT_STORES
export const isStoresType = (type?: MAP_TYPE): boolean =>
	type === MAP_TYPE.STORES
export const isRfidStoresType = (type?: MAP_TYPE): boolean =>
	type === MAP_TYPE.RFID_STORES
export const isDroppointType = (type?: MAP_TYPE): boolean =>
	type === MAP_TYPE.DROPPOINTS
